'use client';

import useUser from '@alltrails/context/hooks/useUser';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import Button from '@alltrails/denali/components/Button';
import useShouldRenderPlusCta from '@/hooks/useShouldRenderPlusCta';
import styles from './styles/styles.module.scss';

// English only - no translations exist for this component
export default function PlusCta() {
  const user = useUser();
  const languageRegionCode = useLanguageRegionCode();
  const renderPlusCta = useShouldRenderPlusCta();

  if (languageRegionCode !== 'en-US' || !renderPlusCta) {
    return null;
  }

  return (
    <div className={styles.buttonContainer}>
      <Button
        text="Start your free trial"
        linkInfo={{
          href: user ? '/plus/checkout' : '/signup?returnTo=%2Fplus%2Fcheckout'
        }}
        testId="location-try-plus"
        variant="primary"
        width="fullOnMobile"
      />
    </div>
  );
}
